import uuid from "uuid";
import clone from 'lodash/clone';

import EventManager from "../../store/sqftEventManager";
import point from "./point";
import lineLength from "./overlays/lineLength";
import pnpoly, {isPointInsidePolygon} from "../../../../lib/pnpoly";
import workspace from "../workspace";
import config from "../../store/sqftConfig";
import {
  addDecimalToLength,
  get45CornerLegDistanceByHypotenuse,
  getClosestPoint,
  getIntersectCords,
  getIntersectCordsBetweenLines,
  getParallelPoints,
  getPointBetweenPoints,
  getPointDistance, getPointField,
  getPointOnTheLine, getTanDeg,
  isInnerCorner,
  measureDistanceToInches,
  orientation
} from "../../../../helpers/sqftHelper";
//todo sqft-react
import bumpout from "./overlays/bumpout";
import label from "./overlays/label";
import LineCorner from "./lineHooks/lineCorner";
// import Color from "./core/draw/color";
import COLOR_THEMES, {COLOR} from "../../store/colorThemes";
import Color from "../workspace/textBox/draw/color";
import store from "../../../../../../store";
import {
  FEATURES_WITH_DISABLED_RESIZING,
  RESOURCE_ATTACHED_TO_NAME,
  RESOURCE_ATTACHED_TO_TYPE,
  RESOURCE_TYPE, SHAPE_PART_ID,
  SIDEBAR_SLAB_SEAM_BUTTONS,
  SQFT_MODE
} from "../../../../constants";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import sqftSlabManager from "../../store/sqftSlabManager";
import {addMiteredSection} from "../../../../../../actions/sqftMiteredFunctions";
import {addResource, deleteResourceAttachedTo} from "../../../../../../actions/sqftResourceFunctions";
import SqftStore from "../../store/sqftStore";
import {getAngleBetween3Points, getLineDirection, getLineOrientation} from "../../../../helpers/shapeHelper";
import RenderFigures from "../../helpers/renderFigures";
import {
  getLineBordersArrayV2,
  updateMiteredLength,
  updateShapeWaterfallLength,
  updateUnderlaymentLength
} from "../../helpers/lineHelper";
import {isSFTCabinetsGroup} from "../../../../helpers/sqftNavigationHelper";
import MiteredController from "../controls/mitered";
import SlabWorkspace from "../slab/slabWorkspace";
import sqftResourcesManager from "../../store/sqftResoursesManager";
import {BlinkingHighlight, pickPulsedColor} from "../../helpers/commonParts/blink";
import workspaceControllers from "../../store/workspaceControllers";
import {createSlabModeWaterfallShapes} from "../../store/canvasHelper";
import {isMiterEdge, isWaterfallFeature} from "../../../../helpers/featureHelper";
import {getCurrentLayout} from "../../../../../appLayout";
import LineAttachmentsComposite from "./lineHooks/lineAttachmentsComposite";
import UnderlaymentController from "../controls/underlayment";
import sqftEventManager from "../../store/sqftEventManager";
import moveLinePreserveAllAngles from "../../helpers/moveLineHelper";
//import {updateShape} from "../controls/labels/labelsHelper";
// import Menu from "../controls/menu";
// import MiteredController from "../controls/mitered";

export default function (from, to, parent = null) {
  //private variables
  var self = this,
    //parent = null,
    state = {
      mousePos: {},
      mouseDown: false,
      mouseDownPosition: null,
      isHovering: false,
      withEdge: false,
      withBacksplash: false,
      withWall: false,
      withBumpout: false,
      isWithMitered: false, // mitered tool
      isWithUnderlayment: false,
      isWithWaterfallEdge: false, // waterfallTool edges
      isWithPeninsulaUnderwrapEdge: false, // Peninsula Underwrap Edge edges
      isWithFakeEdge: false,
      withId: null,
      attachedHandleId: null,
      attachedHandleUrlV: null,
      attachedHandleUrlH: null,
      attachedCrownMoldingFeatureId: null,
      attachedCrownMoldingUrl: null,
      backsplashFeatureId: null,
      backsplashHeight: 0, //this is backsplash size
      backsplashName: "", //this is backsplash size
      backsplashType: "", //this is backsplash size
      attachedItems: {
        isWithCrownMolding: false,
        isWithEndCap: false,
      },
      movePointDistance: 0, // is needed for diagonal lines
      angleLinePoints: {},
      slabModeSkipMiteredEdgeCreation: false,
      isHiddenForever: false,
      seamCutPoint: null,
    },
    design = {
      aroundLineColor: '#E3E1E3',
      cornerGutterSize: 0.1,
      outlineWidth: 8,
      outlineMargin: 9,
      horizontalOutlineMargin: 5,
      lineThickness: 4
    },
    overlayImportData = null,
    lineCornerImportData = null,
    overlayMiteredData = null,
    overlayUnderlaymentData = null,
    waterfallImportData = null,
    lineDirection = {};
  //public properties
  this.id = uuid();
  this.from = from;
  this.to = to;
  this.ctx = null;
  this.attachedShape = null;
  this.overlay = null;
  this.lineCorner = null;
  this.bumpoutOverlay = null;
  this.miteredOverlay = null;
  this.waterfallOverlay = null;
  this.labelOverlay = null;
  this.titleOverlay = null;
  this.staticOffset = null;
  this.isLine = true;
  this.blink = new BlinkingHighlight();
  //todo
  this.lineAttachmentsComposite = new LineAttachmentsComposite();

  //private property setters
  function setParent(value) { parent = value; }
  //public property getters
  this.getParent = function() { return parent; };
  this.getAttachedShape = () => { return this.attachedShape; };
  this.getPosition = () => parent.getPosition();
  this.isWithBumpout = function() { return state.withBumpout; };
  this.isWithEdge = function() { return state.withEdge; };
  this.isWithWaterfallToolEdge = () => { return state.isWithWaterfallEdge; };
  this.isWithPeninsulaUnderwrapEdge = () => { return state.isWithPeninsulaUnderwrapEdge; };
  this.isWithBacksplash = () => { return state.withBacksplash; };
  this.isWithMitered = function() { return state.isWithMitered; };
  this.isWithUnderlayment = function() { return state.isWithUnderlayment; };
  this.isWithHandle = function() { return state.attachedHandleId; };
  this.isWithMiteredPrev = function() {
    const prevLine = parent.getPrevLine(self);
    return prevLine.isWithMitered();
  };
  this.isWithMiterEdge = () => {
    const attachedResource = workspace.getAttachedTo(this);
    if (attachedResource) {
      return isMiterEdge(attachedResource.featureId);
    }
  };
  /** this will return if green edge is waterfall (not waterfall tool) */
  this.isWithWaterfallEdgeFeature = () => {
    const attachedResource = workspace.getAttachedTo(this);
    if (attachedResource) {
      return isWaterfallFeature(attachedResource.featureId);
    }
  };
  this.isWithCrownMolding = () => {
    return state.attachedItems.isWithCrownMolding
  }

  this.getAttachedFeature = () => {
    const attachedResource = workspace.getAttachedTo(this);
    const layout = getCurrentLayout();

    return layout.getFeatureById(attachedResource.featureId, true);
  }
  this.isHovering = (shouldExcludePoints = false) => {
    if (!shouldExcludePoints && this.from.isHovering()) {
      return true
    }
    return state.isHovering;
  };
  this.isAngleHovering = function() { return this.lineCorner.state.isHovering; };
  this.isCornerLineHovering = function() { return this.lineCorner.state.isCornerLineHovering; };
  this.getDesign = function() { return design };
  this.getWithId = () => { return state.withId };
  this.setWithId = (value) => { state.withId = value };
  this.getBacksplashHeight = () => { return state.backsplashHeight };
  this.setBacksplashHeight = (value) => {
    //update resource height
    const attachedToResource = {...sqftResourcesManager.getAttachedToLineResource(this)};
    attachedToResource.height = value;
    sqftResourcesManager.updateAttachedToLineResource(attachedToResource);

    state.backsplashHeight = value
    this.overlay.renderBacksplashText(state.backsplashName, state.backsplashType);
  };
  this.getHandleId = () => { return state.attachedHandleId};
  this.setHandleId = (featureId) => { state.attachedHandleId = featureId};
  this.getHandleV3dURL = () => { return state.attachedHandleUrlV};
  this.getHandleH3dURL = () => { return state.attachedHandleUrlH};
  this.setHandleV3dURL = (url) => { state.attachedHandleUrlV = url};
  this.setHandleH3dURL = (url) => { state.attachedHandleUrlH = url};
  this.getCrownMolding3dURL = () => { return state.attachedCrownMoldingUrl};
  this.setCrownMolding3dURL = (url) => { state.attachedCrownMoldingUrl = url};
  this.getCrownMoldingFeatureId = () => { return state.attachedCrownMoldingFeatureId};
  this.setCrownMoldingFeatureId = (url) => { state.attachedCrownMoldingFeatureId = url};
  this.getBacksplashFeatureId = () => { return sqftResourcesManager.getAttachedToLineResource(this).backsplashFeatureId };
  this.setBacksplashFeatureId = (featureId) => {
    state.backsplashFeatureId = featureId

    //update resource feature id
    const attachedToResource = {...sqftResourcesManager.getAttachedToLineResource(this)};
    attachedToResource.backsplashFeatureId = featureId;
    sqftResourcesManager.updateAttachedToLineResource(attachedToResource);

    //update slab shapes feature
    SlabWorkspace.slabAdditionalShapes.updateAdditionalShapeFeature(this, featureId);
  };
  this.setEdgeFeatureId = (featureId) => {
    const layout = getCurrentLayout();
    const feature = layout.getFeatureById(featureId, true);
    this.addEdgeToLine(feature?.getFeatureName(), featureId);

    //update resource feature id
    const attachedToResource = {...sqftResourcesManager.getAttachedToLineResource(this)};
    attachedToResource.featureId = featureId;
    sqftResourcesManager.updateAttachedToLineResource(attachedToResource);
  };

  this.getState = () => { return state };
  this.setStateParams = (params) => {
    state = {...state, ...params};
  };
  this.getPointsFeatures = function () {
    return {
      from: {
        arcLength: self.from.arcLength,
        angle: self.from.angle,
        x: self.from.x,
        y: self.from.y,
        pointDirection: self.from.pointDirection,
        corner: self.from.corner
      },
      to: {
        arcLength: self.to.arcLength,
        angle: self.to.angle,
        x: self.to.x,
        y: self.to.y,
        pointDirection: self.to.pointDirection,
        corner: self.to.corner
      },
    }
  };
  this.getOrientation = () => {
    return getLineOrientation(this.from, this.to);
  };
  this.getAttachedItems = function () {
    let isAnyItemsAttached = false;
    for (const attachedItemKey in state.attachedItems) {
      if (state.attachedItems[attachedItemKey]) {
        isAnyItemsAttached = true
      }
    }
    return state.withEdge
      || state.withBacksplash
      || state.withWall
      || state.withBumpout
      || state.isWithMitered
      || state.isWithUnderlayment
      || this.isWithWaterfallToolEdge()
      || this.isWithPeninsulaUnderwrapEdge()
      || state.withId
      || isAnyItemsAttached
  };
  this.setTutotialImage = function (image) {
    self.tutorialImage = image
  };
  this.isWithFakeEdge = () => { return state.isWithFakeEdge }
  this.setFakeEdge = (value) => { state.isWithFakeEdge = value };
  this.setHiddenForever = (value) => { state.isHiddenForever = value }; // this is for slab placeholder

  //private functions
  this.calculateRenderPosition = (point, sqftMode) => {
    const state = store.getState();
    const isShowSlabTool = state.sqftSlabState.isShowSlabTool;
    let offset = this.staticOffset ? this.staticOffset : this.getOffset();
    let scale = config.scale;
    let xCord = 0;
    let yCord = 0;
    if (!isShowSlabTool || sqftMode === SQFT_MODE.regular) {
      xCord = point.pos.x;
      yCord = point.pos.y;
    } else {
      if (point.posSlab) {
        xCord = point.posSlab.x;
        yCord = point.posSlab.y;
      } else {
        console.error("point.posSlab was not set");
      }
    }

    return {
      x: (xCord * scale) + offset.x,
      y: (yCord * scale) + offset.y
    };
  };
  // function calculatePointPosition(renderPoint) {
  //   var offset = self.getOffset();
  //   var scale = config.scale;
  //   return {
  //     x: (renderPoint.x - offset.x) / scale,
  //     y: (renderPoint.y - offset.y) / scale
  //   };
  // }

  const getLineField = () => {
    var fieldSquares = {
      from: null,
      to: null,
      points: [],
      isHovering: state.isHovering,
    };

    fieldSquares.from = self.from.getPointField();
    fieldSquares.to = self.to.getPointField();
    var lineOrientation = getLineOrientation(this.from, this.to);
    if (lineOrientation == orientation.HORIZONTAL || lineOrientation == orientation.VERTICAL) {
      if (self.from.x > self.to.x) {
        var x = fieldSquares.from.x;
        fieldSquares.from.x = fieldSquares.to.x;
        fieldSquares.to.x = x;
      }
      if (self.from.y > self.to.y) {
        var y = fieldSquares.from.y;
        fieldSquares.from.y = fieldSquares.to.y;
        fieldSquares.to.y = y;
      }
    }

    var f = fieldSquares.from;
    var t = fieldSquares.to;
    var fieldSquareResizeRatio = 2,
      squeezeRatio = 0,
      marginFromCenter = 10;

    // var windowWidth = $(window).width(),
    //     fieldSquareResizeRatio = 0;
    // if (windowWidth <= 1024) {
    //   fieldSquareResizeRatio = 10;
    // }
    // if (windowWidth <= 768) {
    //   fieldSquareResizeRatio = 15;
    // }

    switch(lineDirection.orientation) {
      case "horizontal": {
        if (lineDirection.newDirection === "east") {
          squeezeRatio =((t.x + f.width/2) - (f.x + f.width/2)) > 80 ? 15 : 0;
          fieldSquares.points.push({x: f.x + f.width/2 + squeezeRatio, y: f.y + fieldSquareResizeRatio - marginFromCenter});
          fieldSquares.points.push({x: t.x + f.width/2 - squeezeRatio, y: t.y + fieldSquareResizeRatio - marginFromCenter});
          fieldSquares.points.push({x: t.x + f.width/2 - squeezeRatio, y: t.y + t.height - fieldSquareResizeRatio - marginFromCenter});
          fieldSquares.points.push({x: f.x + f.width/2 + squeezeRatio, y: f.y + f.height - fieldSquareResizeRatio - marginFromCenter});
        } else if (lineDirection.newDirection === "west") {
          squeezeRatio =((t.x + f.width/2) - (f.x + f.width/2)) > 80 ? 15 : 0;
          fieldSquares.points.push({x: f.x + f.width/2 + squeezeRatio, y: f.y + fieldSquareResizeRatio + marginFromCenter});
          fieldSquares.points.push({x: t.x + f.width/2 - squeezeRatio, y: t.y + fieldSquareResizeRatio + marginFromCenter});
          fieldSquares.points.push({x: t.x + f.width/2 - squeezeRatio, y: t.y + t.height - fieldSquareResizeRatio + marginFromCenter});
          fieldSquares.points.push({x: f.x + f.width/2 + squeezeRatio, y: f.y + f.height - fieldSquareResizeRatio + marginFromCenter});
        }
        break;
      }
      case "vertical": {
        if (lineDirection.newDirection === "south") {
          squeezeRatio =((t.y + t.height/2) - (f.y + t.height/2)) > 80 ? 15 : 0;
          fieldSquares.points.push({x: f.x + fieldSquareResizeRatio + marginFromCenter, y: f.y + t.height/2 + squeezeRatio});
          fieldSquares.points.push({x: f.x + f.width - fieldSquareResizeRatio + marginFromCenter, y: f.y + t.height/2 + squeezeRatio});
          fieldSquares.points.push({x: t.x + t.width - fieldSquareResizeRatio + marginFromCenter, y: t.y + t.height/2 - squeezeRatio});
          fieldSquares.points.push({x: t.x + fieldSquareResizeRatio + marginFromCenter, y: t.y + t.height/2 - squeezeRatio });
        } else if (lineDirection.newDirection === "north") {
          squeezeRatio =((t.y + t.height/2) - (f.y + t.height/2)) > 80 ? 15 : 0;
          fieldSquares.points.push({x: f.x + fieldSquareResizeRatio - marginFromCenter, y: f.y + t.height/2 + squeezeRatio});
          fieldSquares.points.push({x: f.x + f.width - fieldSquareResizeRatio - marginFromCenter, y: f.y + t.height/2 + squeezeRatio});
          fieldSquares.points.push({x: t.x + t.width - fieldSquareResizeRatio - marginFromCenter, y: t.y + t.height/2 - squeezeRatio});
          fieldSquares.points.push({x: t.x + fieldSquareResizeRatio - marginFromCenter, y: t.y + t.height/2 - squeezeRatio });
        }
        break;
      }
      case "SOUTHWEST":
      case "NORTHEAST":
        fieldSquares.points.push({x: f.x, y: f.y });
        fieldSquares.points.push({x: t.x, y: t.y });
        fieldSquares.points.push({x: t.x + t.width, y: t.y + t.height });
        fieldSquares.points.push({x: f.x + f.width, y: f.y + f.height });
      break;
      case "NORTHWEST":
      case "SOUTHEAST":
        fieldSquares.points.push({x: f.x + f.width, y: f.y });
        fieldSquares.points.push({x: t.x + t.width, y: t.y });
        fieldSquares.points.push({x: t.x, y: t.y + t.height });
        fieldSquares.points.push({x: f.x, y: f.y + f.height });
      break;
    }
    return fieldSquares;
  }
  // function getDistance(point1, point2) {
  //   var scale = workspace.getScale(),
  //     xDiff = (point2.x - point1.x),
  //     yDiff = (point2.y - point1.y),
  //     distance = Math.sqrt(Math.pow(xDiff, 2) + Math.pow(yDiff, 2));
  //   distance *= (xDiff + yDiff > 0 ? -1 : 1) / scale;
  //   return distance;
  // }
  // function isLeft(a, b, c){
  //   return ((b.x - a.x)*(c.y - a.y) - (b.y - a.y)*(c.x - a.x)) > 0;
  // }
  // function getDistanceToLine(p1, p2, p3) {
  //   var scale = workspace.getScale(),
  //     x0 = p3.x, y0 = p3.y,
  //     x1 = p1.x, y1 = p1.y,
  //     x2 = p2.x, y2 = p2.y,
  //     distanceToLine = Math.abs(
  //       ((y2 - y1) * x0) - ((x2 - x1) * y0) + (x2 * y1) - (y2 * x1)
  //     ) / Math.sqrt(
  //       Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2)
  //     ),
  //     xDiff = (x2 - x1),
  //     yDiff = (y2 - y1);
  //   distanceToLine *= (isLeft(p1, p2, p3) ? -1 : 1) / scale;
  //   return distanceToLine;
  // }
  // function getCanvasDimensions() {
  //   var canvas = workspace.getCanvas(),
  //     canvasWidth = canvas.width,
  //     canvasHeight = canvas.height,
  //     scale = config.scale,
  //     gridSize = config.workspace.gridSize * scale,
  //     adjustedSize = (gridSize / 3),
  //     rulerSize = adjustedSize + 6;
  //   return {
  //     rulerSize: rulerSize,
  //     canvasWidth: canvasWidth,
  //     canvasHeight: canvasHeight
  //   }
  // }
  // function lockPointToCanvas(point) {
  //   var dim = getCanvasDimensions(),
  //     pos = self.calculateRenderPosition(point),
  //     rulerSize = calculatePointPosition({x: dim.rulerSize, y: dim.rulerSize}),
  //     heightWidth = calculatePointPosition({x: dim.canvasWidth, y: dim.canvasHeight}),
  //     drop = false;
  //
  //
  //   console.log('dim', dim);
  //   console.log('pos', pos);
  //   console.log('rulerSize', rulerSize);
  //   console.log('heightWidth', heightWidth);
  //
  //   if (pos.x < dim.rulerSize) {
  //     point.x = rulerSize.x + 1;
  //     drop = true;
  //   } else if (pos.x >= dim.canvasWidth) {
  //     point.x = heightWidth.x - 1;
  //     drop = true;
  //   }
  //   if (pos.y < dim.rulerSize) {
  //     point.y = rulerSize.y + 1;
  //     drop = true;
  //   } else if (pos.y >= dim.canvasHeight) {
  //     point.y = heightWidth.y - 1;
  //     drop = true;
  //   }
  //   if (drop) {
  //     state.isHovering = false;
  //     state.mouseDown = false;
  //   }
  //   return point;
  // }

  function setMouseOverLine(mousePos) {
    var field = getLineField();
    var vertx = [];
    var verty = [];
    for(var i = 0; i < field.points.length; i++) {
      vertx.push(field.points[i].x);
      verty.push(field.points[i].y);
    }
    state.isHovering = pnpoly(field.points.length, vertx, verty, mousePos.x, mousePos.y);

    return state.isHovering || state.mouseDown;
  }

  /*
  * This is more accurate hover area used for cabinets
   */
  this.getMouseOverLineV2 = (mousePos) => {
    this.updateLineHovering(mousePos)
    return state.isHovering || state.mouseDown;
  }
  this.updateLineHovering = (mousePos = sqftEventManager.getMousePos()) => {
    state.isHovering = isPointInsidePolygon(mousePos, getLineBordersArrayV2(this.from, this.to, design.lineThickness + design.lineThickness * 0.2));
  }
  this.getLineHovering = () => {
    return state.isHovering
  }

  function onMouseUp(mousePos, e) {
    void mousePos;
    void e;
    if (state.mouseDown) {
      state.mouseDown = false;
      state.mouseDownPosition = null;
      self.from.snapToGrid();
      self.to.snapToGrid();
    }
  }
  const onMouseDown = (mousePos, e) => {
    void e;
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;

    if (( EventManager.getCursor().indexOf("n-resize") >= 0
      || EventManager.getCursor().indexOf("e-resize") >= 0
      || EventManager.getCursor().indexOf("ne-resize") >= 0
      || EventManager.getCursor().indexOf("nw-resize") >= 0
    ) && state.isHovering
    ){
      state.mouseDown = true;
      state.movePointDistance = getPointDistance(self.from, self.to);
      state.mouseDownPosition = mousePos;
      return true;
    }

    //Add free seam cut point in the slabMode
    if (activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addFreeSeam && this.isHovering()) {
      const hoveredLines = workspace.getHoveredLines();
      for (const line of hoveredLines) {
        const shape = line.getParent();
        shape.shapeSlab.addFreeSeamPoint(mousePos, line);
      }
      return true;
    }

    return false;
  }
  const onMouseMove = (mousePos, e) => {
    void e;
    // if (e.terminate && !parent.isHovering()) {
    //   state.isHovering = false;
    //   return false;
    // }
    const isCabinet = isSFTCabinetsGroup();
    const isSlabMode = SqftStore.isSlabMode();
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;

    const isMouseOverLine = isCabinet || isSlabMode ? this.getMouseOverLineV2(mousePos) : setMouseOverLine(mousePos);
    if (isMouseOverLine) {
      if (workspace.getAllowEdges() && !self.from.angleIsChanged && !self.to.angleIsChanged) {
        const featureName = parent?.getFeature()?.getFeatureName();
        const isResizingEnabled = !FEATURES_WITH_DISABLED_RESIZING.includes(featureName);
        if (state.mouseDown && isResizingEnabled) {
          this.moveLine(mousePos);
        }
        EventManager.releaseStealLock(parent);
        EventManager.stealCursor();
        switch(getLineOrientation(this.from, this.to)) {
          case orientation.HORIZONTAL:
            EventManager.setCursor("n-resize", self);
            break;
          case orientation.VERTICAL:
            EventManager.setCursor("e-resize", self);
            break;
          case orientation.NORTHWEST:
          case orientation.SOUTHEAST:
            EventManager.setCursor("ne-resize", self);
            break;
          case orientation.NORTHEAST:
          case orientation.SOUTHWEST:
            EventManager.setCursor("nw-resize", self);
            break;
        }
        return state.mouseDown;
      } else if (activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addFreeSeam && isSlabMode) {
        const hoveredShape = parent;

        if (hoveredShape && hoveredShape.shapeSlab) {
          // Check validation for current mouse position
          const validation = hoveredShape.shapeSlab.__seamTool.canAddFreeSeamPoint(mousePos, this);

          // Don't store or render if validation is null (boundary crossing)
          if (validation === null) {
            hoveredShape.shapeSlab.setFreeSeamValidation(this.id, null);
            EventManager.resetCursor(self);
            return true;
          }

          // Store validation in ShapeSlab
          hoveredShape.shapeSlab.setFreeSeamValidation(this.id, validation);

          // Set cursor
          if (validation.canAdd) {
            EventManager.setCursor('pointer', self);
          } else {
            EventManager.setCursor('not-allowed', self);
          }

          return true;
        }
      }

      if (config.highlight.lines && state.isHovering) {
        EventManager.releaseStealLock(parent);
        EventManager.stealCursor();
        return false;
      }
      // prevent all other mouseover's
      if (this.getAttachedItems()) {
        return true
      }
    }

    if (parent && parent.shapeSlab) {
      parent.shapeSlab.setFreeSeamValidation(this.id, null);
    }

    this.lineCorner.updateCornerHoverState(mousePos);

    if (workspace.getHoverShape() !== parent) {
      //state.isHovering = false; // allow hovering multiple shapes
    }
    EventManager.resetCursor(self);
    return false;
  }

  function onMouseLeave() {
    state.isHovering = false;
    state.mouseDown = false;
  }

  //public functions
  this.export = () => {
    return {
      id: this.id,
      from: this.from.export(),
      to: this.to.export(),
      bumpout: this.bumpoutOverlay ? this.bumpoutOverlay.export() : null,
      //todo
      mitered: this.miteredOverlay ? this.miteredOverlay.export() : null,
      underlayment: this.underlaymentOverlay ? this.underlaymentOverlay.export() : null,
      waterfallData: this.waterfallOverlay ? this.waterfallOverlay.export() : null,
      label: this.labelOverlay ? this.labelOverlay.export() : null,
      titleOverlay: this.titleOverlay ? this.titleOverlay.export() : null,
      overlay: this.overlay ? this.overlay.export() : null,
      lineCorner: this.lineCorner ? this.lineCorner.export() : null,
      state: clone(state),
    }
  };

  this.import = (value, existing, shape = null) => {
    state = value.state;
    overlayImportData = value.overlay;
    lineCornerImportData = value.lineCorner;
    setParent(shape);
    var foundFrom = null, foundTo = null;
    for (var i = 0; i < existing.length && !(foundFrom && foundTo); i++) {
      if (!foundFrom && existing[i].from.id == value.from.id) {
        foundFrom = existing[i].from;
      } else if (!foundFrom && existing[i].to.id == value.from.id) {
        foundFrom = existing[i].to;
      } else if (!foundTo && existing[i].to.id == value.to.id) {
        foundTo = existing[i].to;
      } else if (!foundTo && existing[i].from.id == value.to.id) {
        foundTo = existing[i].from;
      }
    }
    self.id = value.id;
    if (foundFrom) {
      self.from = foundFrom;
    } else {
      self.from = new point();
      self.from.import(value.from);
    }
    if (foundTo) {
      self.to = foundTo;
    } else {
      self.to = new point();
      self.to.import(value.to);
    }
    if (value.bumpout) {
      // self.overlay.setMidpointOffset(value.overlay.midpoint.xOffset, value.overlay.midpoint.yOffset);
      self.bumpoutOverlay = new bumpout();
      self.bumpoutOverlay.import(self, value.bumpout);
      state.withBumpout = true;
    }
    if (value.mitered) {
      //addMiteredToLine
      if (workspace.miteredController === null) {
        workspace.miteredController = new MiteredController();
      }
      this.miteredOverlay = workspace.miteredController.createMiteredOverlay(this);
      this.miteredOverlay.import(self, value.mitered);
      overlayMiteredData = value.mitered;
      state.isWithMitered = true;
      store.dispatch(addMiteredSection(this.miteredOverlay));
    }
    if (value.underlayment) {
      //addMiteredToLine isWithUnderlayment
      if (workspace.underlaymentController === null) {
        workspace.underlaymentController = new UnderlaymentController();
      }
      this.underlaymentOverlay = workspace.underlaymentController.createUnderlaymentOverlay(this);
      this.underlaymentOverlay.import(this, value.underlayment);
      overlayUnderlaymentData = value.underlayment;
      state.isWithUnderlayment = true;
      store.dispatch(addResource(RESOURCE_TYPE.underlaymentSections, this.underlaymentOverlay));
    }
    if (value.label) {
      // self.overlay.setMidpointOffset(value.overlay.midpoint.xOffset, value.overlay.midpoint.yOffset);
      self.labelOverlay = new label();
      self.labelOverlay.init(self, value.label.state?.labelText, value.label.state?.partId);
      self.labelOverlay.import(value.label);

      //update shape feature from label after shapes init
      setTimeout(() => {
        //updateShape(value.label.state?.partId, shape);
      }, 1);
    }
    if (value.titleOverlay) {
      // self.overlay.setMidpointOffset(value.overlay.midpoint.xOffset, value.overlay.midpoint.yOffset);
      self.titleOverlay = new label();
      self.titleOverlay.init(self, value.titleOverlay.state.labelText, value.titleOverlay.state.partId);
      self.titleOverlay.import(value.titleOverlay);
    }
    if (value.waterfallData) {
      waterfallImportData = value.waterfallData
      //this.waterfallOverlay = workspaceControllers.waterfall.createWaterfallOverlay(this, value.waterfallData);
    }
  };
  this.init = (parent, temp) => {
    temp = temp || false;
    setParent(parent);
    this.lineCorner = new LineCorner(this);
    if (lineCornerImportData) {
      this.lineCorner.import(lineCornerImportData);
    }
    if (!temp) {
      this.initEvents();
      self.from.init(self);
    }
    if (!temp && !parent.shapeCabinet && parent.partId !== SHAPE_PART_ID.spacer) {
      this.overlay = new lineLength();
      this.overlay.init(self);
      if (overlayImportData) {
        this.overlay.import(overlayImportData);
      }
    }
    if (this.miteredOverlay) {
      this.miteredOverlay.init(overlayMiteredData); // init after import
      //store.dispatch(addMiteredSection(this.miteredOverlay));
      //Menu.miteredController.updateInfo();
      //this.miteredOverlay.afterImport(overlayMiteredData);
    }
    if (this.underlaymentOverlay) {
      this.underlaymentOverlay.init(overlayUnderlaymentData);
    }
    if (waterfallImportData) {
      this.addWaterfallToLine(RESOURCE_ATTACHED_TO_NAME.waterfall, waterfallImportData);
    }
    if (this.isWithWaterfallToolEdge()) {
      this.overlay.renderWaterfallText(RESOURCE_ATTACHED_TO_NAME.waterfall, RESOURCE_ATTACHED_TO_TYPE.waterfall);
    }

    lineDirection = parent.getAngleDirection(self); // {direction:{x: "forward", y: "forward"},facing:"sw"}, cornerMargins, orientation. newDirection

    if (self.historyPointFeatures) {
      self.from.angle = self.historyPointFeatures.from.angle;
      self.from.arcLength = self.historyPointFeatures.from.arcLength;
      self.from.x = self.historyPointFeatures.from.x;
      self.from.y = self.historyPointFeatures.from.y;
      self.from.pointDirection = self.historyPointFeatures.from.pointDirection;
      self.from.corner = self.historyPointFeatures.from.corner;

      self.to.angle = self.historyPointFeatures.to.angle;
      self.to.arcLength = self.historyPointFeatures.to.arcLength;
      self.to.x = self.historyPointFeatures.to.x;
      self.to.y = self.historyPointFeatures.to.y;
      self.to.pointDirection = self.historyPointFeatures.to.pointDirection;
      self.to.corner = self.historyPointFeatures.to.corner;

      self.historyPointFeatures = null;
    }

    // console.log('lineDirection', lineDirection);
  };
  this.initEvents = () => {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      onMouseUp,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_LEAVE,
      onMouseLeave,
      this,
      EventManager.priorities.OVERALL
    );
  };
  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.from.deregisterEvents();
    this.overlay.deregisterEvents();
    if (this.bumpoutOverlay) {
      this.bumpoutOverlay.deregisterEvents();
    }
    if (this.miteredOverlay) {
      this.miteredOverlay.deregisterEvents();
    }
    if (this.titleOverlay) {
      this.titleOverlay.deregisterEvents();
    }
    if (this.overlay) {
      this.overlay.deregisterEvents();
    }
  };
  this.reInitEvents = () => {
    if (state.isHiddenForever) {
      return
    }
    this.initEvents();
    this.from.reInitEvents();
    if (!this.miteredOverlay) {
      this.overlay.reInitEvents();
    }
    if (this.bumpoutOverlay) {
      this.bumpoutOverlay.deregisterEvents();
    }
    if (this.miteredOverlay) {
      this.miteredOverlay.reInitEvents();
    }
    if (this.titleOverlay) {
      this.titleOverlay.reInitEvents();
    }
    if (this.overlay) {
      this.overlay.reInitEvents();
    }
  };
  this.deregisterPartEvents = () => {
    if (this.bumpoutOverlay) {
      this.bumpoutOverlay.deregisterEvents();
    }
    if (this.miteredOverlay) {
      this.miteredOverlay.deregisterEvents();
    }
    if (this.underlaymentOverlay) {
      this.underlaymentOverlay.deregisterEvents();
    }
    if (this.labelOverlay) {
      this.labelOverlay.deregisterPartEvents();
    }
    if (this.titleOverlay) {
      this.titleOverlay.deregisterPartEvents();
    }
    if (this.overlay) {
      this.overlay.deregisterEvents();
    }
    this.from.deregisterPartEvents();
  };
  this.reInitPartEvents = () => {
    if (this.bumpoutOverlay) {
      this.bumpoutOverlay.reInitEvents();
    }
    if (this.miteredOverlay) {
      this.miteredOverlay.reInitEvents();
    }
    if (this.underlaymentOverlay) {
      this.underlaymentOverlay.deregisterEvents();
    }
    if (this.labelOverlay) {
      this.labelOverlay.reInitPartEvents();
    }
    if (this.titleOverlay) {
      this.titleOverlay.reInitPartEvents();
    }
    if (this.overlay && !this.miteredOverlay) {
      this.overlay.reInitEvents();
    }
    this.from.reInitPartEvents();
  };
  this.reInitTitleEvents = () => {
    if (this.titleOverlay) {
      this.titleOverlay.reInitPartEvents();
    }
  };
  this.destroy = function(protect) {
    if (!protect) {
      var image = workspace.getImagesAttachedTo(self);
      if (image) {
        image.destroy();
      }
      EventManager.removeEvent(self);
      self.from.destroy();
      if (self.overlay)
        self.overlay.destroy();
      if (self.miteredOverlay) {
        self.miteredOverlay.destroy();
      }
    }
  };
  this.moveLine = (mousePos) => {

    // console.log("mousePos", mousePos);
    // console.log("self.from.x", self.from.x);
    // console.log("self.from.x", self.to.x);

    const scale = workspace.getScale();

    const xDiff = (state.mouseDownPosition.x - mousePos.x) / scale;
    const yDiff = (state.mouseDownPosition.y - mousePos.y) / scale;
    // var slope = -getSlope(); // OLD LOGIC, let's keep it in case we found an issue with this moveDiagonalLine(see git diff)

    const nextLine = parent.getNextLine(self);
    const prevLine = parent.getPrevLine(self);
    moveLinePreserveAllAngles(this, nextLine, prevLine, -xDiff, -yDiff);

    state.mouseDownPosition = mousePos;

    // var o = getLineOrientation(this.from, this.to);
    // if (o === orientation.VERTICAL) {
    //   self.from.x -= xDiff;
    //   self.to.x -= xDiff;
    //   if (self.isWithBumpout()) {
    //     self.bumpoutOverlay.moveBumpout(xDiff, 0);
    //   } else if (self.isWithMitered()) {
    //     self.miteredOverlay.moveMitered(xDiff, 0);
    //   } else if (this.isWithUnderlayment()) {
    //     this.underlaymentOverlay.moveMitered(xDiff, 0);
    //   }
    //   state.mouseDownPosition.x = mousePos.x;
    // } else if (o === orientation.HORIZONTAL) {
    //   self.from.y -= yDiff;
    //   self.to.y -= yDiff;
    //   if (self.isWithBumpout()) {
    //     self.bumpoutOverlay.moveBumpout(0, yDiff);
    //   } else if (self.isWithMitered()) {
    //     self.miteredOverlay.moveMitered(0, yDiff);
    //   } else if (this.isWithUnderlayment()) {
    //     this.underlaymentOverlay.moveMitered(0, yDiff);
    //   }
    //   state.mouseDownPosition.y = mousePos.y;
    // } else {
    //   const nextLine = parent.getNextLine(self);
    //   const prevLine = parent.getPrevLine(self);
    //   moveLinePreserveAllAngles(this, nextLine, prevLine, -xDiff, -yDiff);
    //   state.mouseDownPosition = mousePos;
    // }

    // self.from = lockPointToCanvas(self.from);  //  removed locking because of this issue http://jira.mozidev.com/browse/QC-802
    // self.to = lockPointToCanvas(self.to);

    updateShapeWaterfallLength(this);
    updateMiteredLength(this);
    updateUnderlaymentLength(this);

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };
  this.getLineDirection = function() {
    return parent.getAngleDirection(self); // line text direction
  };
  this.getLineDirectionV2 = function() {
    return getLineDirection(this.from, this.to); // line text direction
  };
  this.getPairedLines = function() {
    let pairedLines = [];
    switch (parent.shapeType) {
      case "horseshoe": {
        const prevLine = parent.getPrevLine(self);
        const nextLine = parent.getNextLine(self);
        const prevLineStep2 = parent.getPrevLine(prevLine);
        const nextLineStep2 = parent.getNextLine(nextLine);
        const prevLineStep3 = parent.getPrevLine(prevLineStep2);
        const nextLineStep3 = parent.getNextLine(nextLineStep2);

        pairedLines = [nextLineStep3, prevLineStep3];
        break;
      }
      default:
        pairedLines = [parent.getPrevLine(self), parent.getNextLine(self)];
        break;
    }

    return pairedLines;
  };
  this.getLineLength = function () {
    let distance = getPointDistance(self.from, self.to);

    return self.addDecimalToLength(measureDistanceToInches(distance))
  };

  this.getLineLengthMm = function () {
    let distance = getPointDistance(self.from, self.to);

    return measureDistanceToInches(distance).millimeters
  };

  this.getLineDistance = function () {
    return getPointDistance(self.from, self.to);
  };

  this.getLineBumpoutTotalHeight = function () {
    return self.addDecimalToLength(self.bumpoutOverlay.getBumpoutTotalHeight())
  };

  this.addDecimalToLength = function(lineLength) {
    return addDecimalToLength(lineLength);
  };
  this.getBiggestXPoint = function() {
    return self.from.x > self.to.x ? self.from : self.to
  };
  this.getBiggestYPoint = function() {
    return self.from.y > self.to.y ? self.from : self.to
  };
  this.getSmallestXPoint = function() {
    return self.from.x < self.to.x ? self.from : self.to
  };
  this.getSmallestYPoint = function() {
    return self.from.y < self.to.y ? self.from : self.to
  };
  /**
   * @deprecated use getLinePointsWithoutCorners
   * @return {[null, null, ("default"|*), ("default"|*)]}
   */
  this.getSmallestAndBiggestPointWithCorners = () => {
    let o = getLineOrientation(this.from, this.to),
      lineDirection = this.getLineDirection(),
      //nextLine = parent.getNextLine(self),
      prevLine = parent.getPrevLine(self),
      toCornerLength = self.to.getArcLength() || self.get45CornerLegDistance(),
      fromCornerLength = prevLine.to.getArcLength() || prevLine.get45CornerLegDistance(),
      toLinePoint = Object.assign({}, self.to),
      fromLinePoint = Object.assign({}, self.from),
      biggestLinePoint = null,
      smallestLinePoint = null,
      toCornerMargin = null,
      fromCornerMargin = null;

    if (o === orientation.VERTICAL) {
      //line biggest and smallest points
      biggestLinePoint = Object.assign({}, this.getBiggestYPoint());
      smallestLinePoint = Object.assign({}, this.getSmallestYPoint());
      if (lineDirection.newDirection === "north" ) {
        toCornerMargin = -fromCornerLength;
        fromCornerMargin = +toCornerLength;
        toLinePoint.y += fromCornerMargin;
        fromLinePoint.y += toCornerMargin;
      } else {
        toCornerMargin = -toCornerLength;
        fromCornerMargin = +fromCornerLength;
        toLinePoint.y += toCornerMargin;
        fromLinePoint.y += fromCornerMargin;
      }
      biggestLinePoint.y += toCornerMargin;
      smallestLinePoint.y += fromCornerMargin;
    } else if (o === orientation.HORIZONTAL) {
      //line biggest and smallest points
      biggestLinePoint = Object.assign({}, this.getBiggestXPoint());
      smallestLinePoint = Object.assign({}, this.getSmallestXPoint());
      if (lineDirection.newDirection === "east" ) {
        toCornerMargin = -toCornerLength;
        fromCornerMargin = +fromCornerLength;
        toLinePoint.x += toCornerMargin;
        fromLinePoint.x += fromCornerMargin;
      } else {
        toCornerMargin = -fromCornerLength;
        fromCornerMargin = +toCornerLength;
        toLinePoint.x += fromCornerMargin;
        fromLinePoint.x += toCornerMargin;
      }
      biggestLinePoint.x += toCornerMargin;
      smallestLinePoint.x += fromCornerMargin;
    }

    return [smallestLinePoint, biggestLinePoint, toLinePoint, fromLinePoint]
  };
  this.getLinePointsWithoutCorners = () => {
    let toCornerLength = this.to.getArcLength(),
      toAngleLength = this.to.getAngle(),
      fromCornerLength = this.from.getArcLength(),
      fromAngleLength = this.from.getAngle();

    const toPoint = getPointOnTheLine(this.to, this.from, -toCornerLength || -toAngleLength);
    const fromPoint = getPointOnTheLine(this.from, this.to, -fromCornerLength || -fromAngleLength);

    return [fromPoint, toPoint]
  }
  this.getOffset = function() {
    var scale = config.scale;
    var workspacePos = workspace.getOffset();
    if (parent) {
      var _pos = parent.getPosition();
      if (config.workspace.snapToGrid) {
        _pos = parent.getSnappedPosition();
      }
      var offset = {
        x: workspacePos.x + (_pos.x * scale),
        y: workspacePos.y + (_pos.y * scale)
      }
    } else {
      return {x: 0, y: 0};
    }
    return offset;
  };
  this.stealCursor = function(who) {
    if (self.from === who) {
      EventManager.resetCursor(self);
    }
  };
  this.resetState = () => {
    state.mouseDown = false;
    state.mouseDownPosition = null;
    state.isHovering = false;
  };
  this.hasIntersections = () => {
    const lines = parent.getLines();
    const fromPosition = getPointField(this.from.x, this.from.y);
    const toPosition = getPointField(this.to.x, this.to.y);

    return lines.some(testLine => {
      const prevLine = parent.getPrevLine(this);
      const nextLine = parent.getNextLine(this);
      // skip closest lines
      if (testLine.id === this.id || testLine.id === prevLine.id || testLine.id === nextLine.id) {
        return false
      }
      const testLineFromPosition = getPointField(testLine.from.x, testLine.from.y);
      const testLineToPosition = getPointField(testLine.to.x, testLine.to.y);
      const intersections = getIntersectCordsBetweenLines(
        fromPosition, toPosition, testLineFromPosition, testLineToPosition
      )
      void intersections;
      // console.log("intersections", intersections);
      // if (intersections) {
      //   console.log("fromPosition", fromPosition);
      //   console.log("toPosition", toPosition);
      //   console.log("testLineFromPosition", testLineFromPosition);
      //   console.log("testLineToPosition", testLineToPosition);
      // }
      return intersections
    })
  }

  /**
   * This will render blue shape
   * @param ctx
   * @param toOnly
   * @param sqftMode
   */
  this.render = (ctx, toOnly, sqftMode) => {
    this.renderLineBorder(ctx, toOnly, sqftMode);
  }

  /**
   * This will render blue shape
   * @param ctx
   * @param toOnly
   * @param sqftMode
   */
  this.renderLineBorder = (ctx, toOnly, sqftMode) => {
    if (workspace && workspace.getState().loading) return;
    this.ctx = ctx;
    toOnly = toOnly || false;
    const renderTo = self.calculateRenderPosition(self.to, sqftMode);
    const renderFrom = self.calculateRenderPosition(self.from, sqftMode);
    // if (!toOnly) {
    //   let x = renderFrom.x;
    //   let y = renderFrom.y;
    //   if (self.from.arcLength > 0 || self.from.angle > 0) {
    //     const radius = Math.sqrt(Math.pow(self.from.arcLength || self.from.angle, 2) / 2) * config.scale;
    //     const o = getLineOrientation(this.from, this.to);
    //     switch(o) {
    //       case orientation.HORIZONTAL:
    //         if (self.from.x < self.to.x)
    //           x += radius;
    //         else
    //           x -= radius;
    //         break;
    //       case orientation.VERTICAL:
    //         if (self.from.y < self.to.y)
    //           y += radius;
    //         else
    //           y -= radius;
    //         break;
    //       case orientation.NORTHWEST:
    //       case orientation.SOUTHEAST:
    //       case orientation.NORTHEAST:
    //       case orientation.SOUTHWEST:
    //         //todo
    //         break;
    //     }
    //   }
    //   ctx.moveTo(x, y);
    // }

    if (state.withBumpout && !SqftStore.isSlabMode() && !this.isDisabledInPopup) {
      drawBumpoutLine(ctx);
    }
    // don't render arc Length and angle in the slab mode
    if (self.to.arcLength > 0 && !SqftStore.isSlabMode()) { //  changes blue corner if radius or angle exists
      this.renderArcLength(ctx, renderFrom, renderTo);
    } else if (self.to.angle > 0) {
      this.renderAngle(ctx, renderFrom, renderTo);
    } else {
      ctx.lineTo(renderTo.x, renderTo.y);
    }
  }

  this.renderArcLength = (ctx, renderFrom, renderTo) => {
    let radiusMultiplier = this.to.arcLength;
    let radius = radiusMultiplier * config.scale;
    let dir = parent.getAngleDirection(this);

    switch (dir.orientation) {
      case "horizontal":
      case "vertical":
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST":
      default: {
        const nextLine = parent.getNextLine(this);
        const nextLineRenderTo = nextLine.calculateRenderPosition(nextLine.to);
        const angle = getAngleBetween3Points(renderFrom, renderTo, nextLineRenderTo);
        const radiusMultiplier = this.to.arcLength * config.scale;
        const marginFrom = Math.abs(radiusMultiplier / getTanDeg(Math.round(angle / 2)));
        const pointA = getPointBetweenPoints(renderTo, renderFrom, marginFrom); // *2 is made to fit arcTo
        const pointB = getPointBetweenPoints(renderTo, self.calculateRenderPosition(nextLine.to), radius);

        ctx.lineTo(pointA.x, pointA.y);
        //ctx.lineTo(renderFrom.x, renderFrom.y)
        ctx.arcTo(renderTo.x, renderTo.y, pointB.x, pointB.y, radius);
        break;
      }
    }
  };
  this.renderAngle = (ctx, renderFrom, renderTo) => {
    let radiusMultiplier = Math.sqrt( Math.pow(this.to.angle, 2) * 2); //todo
    let radius = radiusMultiplier * config.scale;
    let dir = parent.getAngleDirection(this);

    switch (dir.orientation) {
      case "horizontal":
      case "vertical":
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        const nextLine = parent.getNextLine(this);
        const nextLineRenderTo = this.calculateRenderPosition(nextLine.to);
        const pointA = getPointBetweenPoints(renderTo, renderFrom, radius / 2);
        const pointB = getPointBetweenPoints(renderTo, nextLineRenderTo, radius / 2);
        ctx.lineTo(pointA.x, pointA.y);
        ctx.lineTo(pointB.x, pointB.y);
        break;
      }
      default:
        break;
    }
  };

  this.renderLineOverlay = function(ctx) {
    lineLength.render(ctx, self);
  };

  const highLightBorder = (color) => {
    if (!self.from.angleIsChanged && !self.to.angleIsChanged) {
      let [fromPointWithIndent, toPointWithIndent] = this.getLinePointsWithoutCorners(),
        renderFrom = getPointField(fromPointWithIndent.x, fromPointWithIndent.y, this),
        renderTo = getPointField(toPointWithIndent.x, toPointWithIndent.y, this);
      //
      // let [smallestLinePoint, biggestLinePoint, to, from] = self.getSmallestAndBiggestPointWithCorners(),
      //   renderFrom1    = self.calculateRenderPosition(from),
      //   renderTo1     = self.calculateRenderPosition(to);
      //
      // void smallestLinePoint;
      // void biggestLinePoint;
      // console.log("renderFrom", renderFrom);
      // console.log("renderFrom1", renderFrom1);
      //
      // console.log("renderTo", renderTo);
      // console.log("renderTo1", renderTo1);
      //
      // debugger // eslint-disable-line no-debugger
      self.ctx.beginPath();
      self.ctx.moveTo(renderFrom.x, renderFrom.y);
      if (state.withBumpout) {
        drawBumpoutLine(self.ctx);
      }
      self.ctx.lineTo(renderTo.x, renderTo.y);
      self.ctx.lineWidth = 4;
      self.ctx.strokeStyle = color;
      self.ctx.stroke();
      self.ctx.closePath();

      /*var lineField = getLineField();
      var field = lineField.points;
      self.from.render(self.ctx);

      self.ctx.save();
      self.ctx.beginPath();
      self.ctx.moveTo(field[0].x, field[0].y);
      for(var i = 1; i < field.length; i++) {
        var p = field[i];
        var x = p.x, y = p.y;
        self.ctx.lineTo(x, y);
      }
      self.ctx.closePath();
      self.ctx.fillStyle = 'rgba(159,197,34,0.47)';
      self.ctx.fill();
      self.ctx.restore();*/   // this is old hovering, m.b. would be needed for tests
    }
  }

  function drawBumpoutLine(ctx) {
    var bumpoutPoints = self.bumpoutOverlay.getBumpoutPoints(),
      point1 = self.calculateRenderPosition(bumpoutPoints.point1),
      point2 = self.calculateRenderPosition(bumpoutPoints.point2),
      point3 = self.calculateRenderPosition(bumpoutPoints.point3),
      point4 = self.calculateRenderPosition(bumpoutPoints.point4);

    ctx.lineTo(point1.x, point1.y);
    ctx.lineTo(point2.x, point2.y);
    ctx.lineTo(point3.x, point3.y);
    ctx.lineTo(point4.x, point4.y);
  }

  const drawResizeCursor = () => {
    var
      renderFrom    = self.calculateRenderPosition(self.from),
      renderTo      = self.calculateRenderPosition(self.to);
    var o = getLineOrientation(this.from, this.to);
    const size = +self.tutorialImage.dataset.size;
    if (o === orientation.VERTICAL) {
      self.ctx.drawImage(self.tutorialImage, 0, 0, size, size, renderFrom.x - size/2, renderFrom.y - (renderFrom.y - renderTo.y)/2 - size/2, size, size);
    } else if (o === orientation.HORIZONTAL) {
      self.ctx.drawImage(self.tutorialImage, 0, 0, size, size, renderFrom.x - (renderFrom.x - renderTo.x)/2 - size/2, renderFrom.y - size/2, size, size);
    }
  }

  this.setLinePoints = () => {
    let renderFrom = self.calculateRenderPosition(self.from),
      renderTo = self.calculateRenderPosition(self.to),
      marginFrom = 0,
      marginTo   = 0,
      //len = 0,
      afterIntersectionMargin = 9;
    const prevLine = parent.getPrevLine(self);
    const nextLine = parent.getNextLine(self);
    lineDirection = parent.getAngleDirection(self);

    if (this.from.arcLength > 0) {
      const prevLineRenderFrom = prevLine.calculateRenderPosition(prevLine.from);
      const angle = getAngleBetween3Points(prevLineRenderFrom, renderFrom, renderTo);
      const radiusMultiplier = self.from.arcLength * config.scale;
      marginFrom = Math.abs(radiusMultiplier / getTanDeg(Math.round(angle / 2))) ;

      // console.clear();
      // console.log("self.from.arcLength", self.from.arcLength);
      // console.log("radiusMultiplier", radiusMultiplier);
      // console.log("marginFrom", marginFrom);
      // console.log("angle", angle);
      // console.log("getTanDeg(Math.round(angle / 2))", getTanDeg(Math.round(angle / 2)));
      // console.log("marginFrom < radiusMultiplier", marginFrom < radiusMultiplier);
    } else if (this.from.angle > 0) {
      marginFrom = self.from.angle * config.scale / 1.48 + design.outlineMargin; // +design.outlineMargin is to prevent overlapping
    }

    if (this.to.arcLength > 0) {
      const nextLineRenderTo = nextLine.calculateRenderPosition(nextLine.to);
      const angle = getAngleBetween3Points(renderFrom, renderTo, nextLineRenderTo);
      const radiusMultiplier = this.to.arcLength * config.scale;
      marginTo = Math.abs(radiusMultiplier / getTanDeg(Math.round(angle / 2)));
      // console.clear();
      // console.log("self.to.arcLength", self.to.arcLength);
      // console.log("radiusMultiplier", radiusMultiplier);
      // console.log("marginTo", marginTo);
      // console.log("angle", angle);
      // console.log("getTanDeg(Math.round(angle / 2))", getTanDeg(Math.round(angle / 2)));
      // console.log("marginFrom < radiusMultiplier", marginTo < radiusMultiplier);
    } else if (this.to.angle > 0) {
      marginTo = self.to.angle * config.scale / 1.48; // not sure why 1.48
    }

    self.drawLineFrom = self.drawLineFrom || null;
    self.drawLineTo = self.drawLineTo || null;
    if (state.withBumpout) {
      var bumpoutPoints = self.bumpoutOverlay.getBumpoutPoints(),
       point1 = self.calculateRenderPosition(bumpoutPoints.point1),
       point2 = self.calculateRenderPosition(bumpoutPoints.point2),
       point3 = self.calculateRenderPosition(bumpoutPoints.point3),
       point4 = self.calculateRenderPosition(bumpoutPoints.point4);

      self.drawLineBumpoutPoints = self.drawLineBumpoutPoints || null;
    }

    //let prevParallelLine, nextParallelLine, rotateAnglePart, rotatedAngleValue;


    if (lineDirection.orientation !== "horizontal" && lineDirection.orientation !== "vertical") {
      //nextLineDirection = parent.getAngleDirection(nextLine);
      //prevLineDirection = parent.getAngleDirection(prevLine);
      // prevParallelLine = parent.getPrevLine(prevLine);
      // nextParallelLine = parent.getNextLine(nextLine);
      // rotateAnglePart = self.from.rotateAnglePart;
      // rotatedAngleValue = self.from.rotateAnglePart ? self.from.rotateAnglePart.rotatedAngleValue : 0;
    }

    switch (lineDirection.orientation) {
      case "horizontal":
        if (lineDirection.newDirection === 'east') {
          marginFrom = (prevLine.getLineDirection().newDirection === 'south') ? marginFrom + 18 : marginFrom;
          marginTo = (nextLine.getLineDirection().newDirection === 'north') ? marginTo + 18 : marginTo;
          self.drawLineFrom = {x: renderFrom.x + marginFrom, y: renderFrom.y - 9};
          self.drawLineTo = {x: renderTo.x - marginTo, y: renderTo.y - 9};
          if (state.withBumpout) {
            self.drawLineBumpoutPoints = this.bumpoutOverlay.bumpoutInOrOut() === 'out' ?
              {
                point1: {x: point1.x - 9, y: renderTo.y - 9},
                point2: {x: point2.x - 9, y: point2.y - 9},
                point3: {x: point3.x + 9, y: point3.y - 9},
                point4: {x: point4.x + 9, y: point4.y - 9},
              } : {
                point1: {x: point1.x + 9, y: renderTo.y - 9},
                point2: {x: point2.x + 9, y: point2.y - 9},
                point3: {x: point3.x - 9, y: point3.y - 9},
                point4: {x: point4.x - 9, y: point4.y - 9},
              }
          }
          setPointsOutlineIntersection(prevLine, nextLine);
          self.drawLineFrom = {x: self.drawLineFrom.x + afterIntersectionMargin, y: self.drawLineFrom.y};
          self.drawLineTo = {x: self.drawLineTo.x - afterIntersectionMargin, y: self.drawLineTo.y};
        } else if (lineDirection.newDirection === "west") {
          marginFrom = (prevLine.getLineDirection().newDirection === 'north') ? marginFrom + 18 : marginFrom;
          marginTo = (nextLine.getLineDirection().newDirection === 'south') ? marginTo + 18 : marginTo;
          self.drawLineFrom = {x: renderFrom.x - marginFrom, y: renderFrom.y + 9};
          self.drawLineTo = {x: renderTo.x + 1 + marginTo, y: renderTo.y + 9};

          if (state.withBumpout) {
            self.drawLineBumpoutPoints = this.bumpoutOverlay.bumpoutInOrOut() === 'out' ?
              {
                point1: {x: point1.x + 9, y: renderTo.y + 9},
                point2: {x: point2.x + 9, y: point2.y + 9},
                point3: {x: point3.x - 9, y: point3.y + 9},
                point4: {x: point4.x - 9, y: point4.y + 9},
              } : {
                point1: {x: point1.x - 9, y: renderTo.y + 9},
                point2: {x: point2.x - 9, y: point2.y + 9},
                point3: {x: point3.x + 9, y: point3.y + 9},
                point4: {x: point4.x + 9, y: point4.y + 9},
              }
          }
          setPointsOutlineIntersection(prevLine, nextLine);
          self.drawLineFrom = {x: self.drawLineFrom.x - afterIntersectionMargin, y: self.drawLineFrom.y};
          self.drawLineTo = {x: self.drawLineTo.x + afterIntersectionMargin, y: self.drawLineTo.y};
        }
        break;
      case "vertical":
        if (lineDirection.newDirection === 'south') {
          marginFrom = (prevLine.getLineDirection().newDirection === 'west') ? marginFrom + 18 : marginFrom;
          marginTo = (nextLine.getLineDirection().newDirection === 'east') ? marginTo + 18 : marginTo;
          self.drawLineFrom = {x: renderFrom.x + 9, y: renderFrom.y + marginFrom};
          self.drawLineTo = {x: renderTo.x + 9, y: renderTo.y - marginTo};
          if (state.withBumpout) {
            self.drawLineBumpoutPoints = this.bumpoutOverlay.bumpoutInOrOut() === 'out' ?
              {
                point1: {x: point1.x + 9, y: point1.y - 9},
                point2: {x: point2.x + 9, y: point2.y - 9},
                point3: {x: point3.x + 9, y: point3.y + 9},
                point4: {x: point4.x + 9, y: point4.y + 9},
              } : {
                point1: {x: point1.x + 9, y: point1.y + 9},
                point2: {x: point2.x + 9, y: point2.y + 9},
                point3: {x: point3.x + 9, y: point3.y - 9},
                point4: {x: point4.x + 9, y: point4.y - 9},
              }
          }
          setPointsOutlineIntersection(prevLine, nextLine);
          self.drawLineFrom = {x: self.drawLineFrom.x, y: self.drawLineFrom.y + afterIntersectionMargin};
          self.drawLineTo = {x: self.drawLineTo.x, y: self.drawLineTo.y - afterIntersectionMargin};
        } else if (lineDirection.newDirection === 'north') {
          marginTo = (nextLine.getLineDirection().newDirection === 'west') ? marginTo + 18 : marginTo;
          marginFrom = (prevLine.getLineDirection().newDirection === 'east') ? marginFrom + 18 : marginFrom;
          self.drawLineFrom = {x: renderFrom.x - 9, y: renderFrom.y - marginFrom};
          self.drawLineTo = {x: renderTo.x - 9, y: renderTo.y + marginTo};
          if (state.withBumpout) {
            self.drawLineBumpoutPoints = this.bumpoutOverlay.bumpoutInOrOut() === 'out' ?
              {
                point1: {x: point1.x - 9, y: point1.y + 9},
                point2: {x: point2.x - 9, y: point2.y + 9},
                point3: {x: point3.x - 9, y: point3.y - 9},
                point4: {x: point4.x - 9, y: point4.y - 9},
              } : {
                point1: {x: point1.x - 9, y: point1.y - 9},
                point2: {x: point2.x - 9, y: point2.y - 9},
                point3: {x: point3.x - 9, y: point3.y + 9},
                point4: {x: point4.x - 9, y: point4.y + 9},
              }
          }
          setPointsOutlineIntersection(prevLine, nextLine);
          self.drawLineFrom = {x: self.drawLineFrom.x, y: self.drawLineFrom.y - afterIntersectionMargin};
          self.drawLineTo = {x: self.drawLineTo.x, y: self.drawLineTo.y + afterIntersectionMargin};
        }
        break;
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST":
      default: {
        let distanceFromLine = 9;
        if (marginFrom) {
          const prevLineFrom = this.calculateRenderPosition(prevLine.from);
          if (isInnerCorner(parent, renderFrom, renderTo, prevLineFrom)) {
            marginFrom = marginFrom + 8;
          }
          renderFrom = getPointOnTheLine(renderFrom, renderTo, -marginFrom);
        }
        if (marginTo) {
          const nextLineTo = this.calculateRenderPosition(nextLine.to);
          if (isInnerCorner(parent, renderFrom, renderTo, nextLineTo)) {
            marginTo = marginTo + 8;
          }
          renderTo = getPointOnTheLine(renderTo, renderFrom, -marginTo);
        }

        [this.drawLineFrom, this.drawLineTo] = getParallelPoints(renderTo, renderFrom, distanceFromLine);
        setPointsOutlineIntersection(prevLine, nextLine);
      }
      break;
//       case "SOUTHEAST": {
//         if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
//           if (rotatedAngleValue < 90) {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//             self.drawLineTo = getParralelPoint(self.calculateRenderPosition(nextLine.from), self.calculateRenderPosition(nextLine.to));
//           } else {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           }
//         } else if (rotateAnglePart && rotateAnglePart.angleDirection === "left") {
//           self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//           self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(prevParallelLine.from))
//         } else {
//           [this.drawLineFrom, this.drawLineTo] = getParallelPoints(renderTo, renderFrom, 9);
//
//           RenderFigures.renderCircle(this.drawLineFrom, 12,1, '#63b141');
//           RenderFigures.renderCircle(this.drawLineTo, 10, 1);
//
// debugger // eslint-disable-line no-debugger
//
//           // self.drawLineFrom = {x: renderFrom.x + 9, y: renderFrom.y - 9};
//           // self.drawLineTo = {x: renderTo.x + 9, y: renderTo.y - 9};
//           setPointsOutlineIntersection(prevLine, nextLine);
//         }
//         if (marginFrom) {
//           self.drawLineFrom = getPointBetweenPoints(self.drawLineFrom, self.drawLineTo, marginFrom)
//         }
//         if (marginTo) {
//           self.drawLineTo = getPointBetweenPoints(self.drawLineTo, self.drawLineFrom, marginTo)
//         }
//         break;
//       }
//       case "NORTHEAST": {
//         if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
//           self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//           self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//         } else if (rotateAnglePart && rotateAnglePart.angleDirection === "left") {
//           if (rotatedAngleValue < 90) {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(prevParallelLine.from));
//           } else {
//             // self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           }
//         } else {
//           // self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//           // self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           self.drawLineFrom = {x: renderFrom.x - 9, y: renderFrom.y - 9};
//           self.drawLineTo = {x: renderTo.x - 9, y: renderTo.y - 9};
//           setPointsOutlineIntersection(prevLine, nextLine);
//         }
//         if (marginFrom) {
//           self.drawLineFrom = getPointBetweenPoints(self.drawLineFrom, self.drawLineTo, marginFrom)
//         }
//         if (marginTo) {
//           self.drawLineTo = getPointBetweenPoints(self.drawLineTo, self.drawLineFrom, marginTo)
//         }
//         break;
//       }
//       case "SOUTHWEST": {
//         if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
//           if (rotatedAngleValue < 90 && rotateAnglePart && rotateAnglePart.shapeType !== "wideangle") {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           } else {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(prevParallelLine.from));
//           }
//         } else if (rotateAnglePart && rotateAnglePart.angleDirection === "left") {
//           if (rotatedAngleValue < 90) {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           } else {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(prevParallelLine.from));
//           }
//         } else {
//           // self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//           // self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           self.drawLineFrom = {x: renderFrom.x + 9, y: renderFrom.y + 9};
//           self.drawLineTo = {x: renderTo.x + 9, y: renderTo.y + 9};
//           setPointsOutlineIntersection(prevLine, nextLine);
//         }
//         if (marginFrom) {
//           self.drawLineFrom = getPointBetweenPoints(self.drawLineFrom, self.drawLineTo, marginFrom)
//         }
//         if (marginTo) {
//           self.drawLineTo = getPointBetweenPoints(self.drawLineTo, self.drawLineFrom, marginTo)
//         }
//         break;
//       }
//       case "NORTHWEST": {
//         if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
//           self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//           self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(prevParallelLine.from));
//         } else if (rotateAnglePart && rotateAnglePart.angleDirection === "left") {
//           if (rotatedAngleValue < 90) {
//             // self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           } else {
//             self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(nextParallelLine.to));
//             self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//           }
//         } else {
//           // self.drawLineFrom = getParralelPoint(renderFrom, self.calculateRenderPosition(prevLine.from));
//           // self.drawLineTo = getParralelPoint(renderTo, self.calculateRenderPosition(nextLine.to));
//
//           self.drawLineFrom = {x: renderFrom.x - 9, y: renderFrom.y + 9};
//           self.drawLineTo = {x: renderTo.x - 9, y: renderTo.y + 9};
//           setPointsOutlineIntersection(prevLine, nextLine);
//         }
//         if (marginFrom) {
//           self.drawLineFrom = getPointBetweenPoints(self.drawLineFrom, self.drawLineTo, marginFrom)
//         }
//         if (marginTo) {
//           self.drawLineTo = getPointBetweenPoints(self.drawLineTo, self.drawLineFrom, marginTo)
//         }
//         break;
//       }
      //default:
    }
  };
  const setPointsOutlineIntersection = (prevLine, nextLine) => {
    const fromBorderIntersectionPoint = getBorderFromIntersection(prevLine);
    const fromOutlineIntersectionPoint = getOutlineFromIntersection(prevLine);
    if ((fromBorderIntersectionPoint || fromOutlineIntersectionPoint)
      && !(this.from.isWithAngle())
      && !(this.from.isWithCorner())
    ) {
      let intersectionPoints = [];
      if (fromBorderIntersectionPoint) intersectionPoints.push(fromBorderIntersectionPoint);
      if (fromOutlineIntersectionPoint) intersectionPoints.push(fromOutlineIntersectionPoint);
      const closestIntersectionPoint = getClosestPoint(self.drawLineTo, intersectionPoints);

      // render dev circles intersection
      // if (lineDirection.orientation === "NORTHWEST") {
      //   if (fromBorderIntersectionPoint) RenderFigures.renderCircle(fromBorderIntersectionPoint, 10,1, '#e5bf37')
      //   if (fromOutlineIntersectionPoint) RenderFigures.renderCircle(fromOutlineIntersectionPoint, 10,1, '#de5f5f')
      //   RenderFigures.renderCircle(closestIntersectionPoint, 20,1, '#63b141');
      //   RenderFigures.renderCircle(self.drawLineTo, 25, 1);
      //   debugger // eslint-disable-line no-debugger
      // }
      if (closestIntersectionPoint.x && closestIntersectionPoint.y) {
        this.drawLineFrom = {x: closestIntersectionPoint.x, y: closestIntersectionPoint.y};
      }
    }

    const toBorderIntersectionPoint = getBorderToIntersection(nextLine);
    const toOutlineIntersectionPoint = getOutlineToIntersection(nextLine);

    if ((toBorderIntersectionPoint || toOutlineIntersectionPoint)
      && !(this.to.isWithAngle())
      && !(this.to.isWithCorner())
    ) {
      let intersectionPoints = [];
      if (toBorderIntersectionPoint) { intersectionPoints.push(toBorderIntersectionPoint)}
      if (toOutlineIntersectionPoint) { intersectionPoints.push(toOutlineIntersectionPoint)}
      const closestIntersectionPoint = getClosestPoint(self.drawLineFrom, intersectionPoints);
      void RenderFigures.renderCircle;
      // if (lineDirection.orientation === "SOUTHWEST") {
      //   if (toBorderIntersectionPoint) RenderFigures.renderCircle(toBorderIntersectionPoint, 10,1, '#e5bf37')
      //   if (toOutlineIntersectionPoint) RenderFigures.renderCircle(toOutlineIntersectionPoint,  15,1, '#de5f5f')
      //   RenderFigures.renderCircle(closestIntersectionPoint, 20, 1, '#63b141');
      //   RenderFigures.renderCircle(self.drawLineFrom, 25);
      //   debugger // eslint-disable-line no-debugger
      // }
      if (closestIntersectionPoint.x && closestIntersectionPoint.y) {
        this.drawLineTo = {x: closestIntersectionPoint.x, y: closestIntersectionPoint.y};
      }
    }

    // todo bumpout
    // self.drawLineBumpoutPoints = state.withBumpout ?
    //   {
    //     point1: {x: point1.x + 9, y: point1.y - 9},
    //     point2: {x: point2.x + 9, y: point2.y - 9},
    //     point3: {x: point3.x + 9, y: point3.y + 9},
    //     point4: {x: point4.x + 9, y: point4.y + 9},
    //   } : null;
  }
  // const getOutlineIntersectionPointWithPrevLine = () => {
  //   const prevLine = parent.getPrevLine(this);
  //   if (!prevLine.drawLineTo) {
  //     debugger // eslint-disable-line no-debugger
  //     prevLine.setLinePoints();
  //   }
  //
  //   const pointOnTheLine = getPointOnTheLine(this.drawLineTo, this.drawLineFrom, 300);
  //   const pointOnThePrevLine = getPointOnTheLine(prevLine.drawLineFrom, prevLine.drawLineTo, 300);
  //   console.log("this", this);
  //   debugger // eslint-disable-line no-debugger
  //   return getIntersectCords(
  //     this.drawLineFrom.x,
  //     this.drawLineFrom.y,
  //     pointOnTheLine.x,
  //     pointOnTheLine.y,
  //     pointOnThePrevLine.x,
  //     pointOnThePrevLine.y,
  //     prevLine.drawLineFrom.x,
  //     prevLine.drawLineFrom.y,
  //   );
  // }

  const getOutlineIntersectionPointWithNextTLine = () => {
    const nextLine = parent.getNextLine(this);
    nextLine.setLinePoints();
    const pointOnTheLine = getPointOnTheLine(this.drawLineTo, this.drawLineFrom, 1000);
    const pointOnTheNextLine = getPointOnTheLine(nextLine.drawLineFrom, nextLine.drawLineTo, 1000);
    return getIntersectCords(
      this.drawLineFrom.x,
      this.drawLineFrom.y,
      pointOnTheLine.x,
      pointOnTheLine.y,
      pointOnTheNextLine.x,
      pointOnTheNextLine.y,
      nextLine.drawLineFrom.x,
      nextLine.drawLineFrom.y,
    );
  }
  const getBorderToIntersection = (nextLine) => {
    let intersectionCords = false
    if (nextLine.drawLineTo) {
      const nextLineToPointField = nextLine.to.getPointField(false);
      const nextLineFromPointField = nextLine.from.getPointField(false);
      const pointOnTheLine = getPointOnTheLine(self.drawLineTo, self.drawLineFrom,25);
      const pointOnTheNextLine = getPointOnTheLine(nextLineFromPointField, nextLineToPointField, 25);

      intersectionCords = getIntersectCords(
        self.drawLineFrom.x,
        self.drawLineFrom.y,
        pointOnTheLine.x,
        pointOnTheLine.y,
        pointOnTheNextLine.x,
        pointOnTheNextLine.y,
        nextLineToPointField.x,
        nextLineToPointField.y,
      );
      // if (lineDirection.orientation === "SOUTHWEST") {
      //   console.log("--------");
      //   console.log("pointOnTheLine", pointOnTheLine);
      //   console.log(" self.drawLineFrom", self.drawLineFrom);
      //   console.log(" self.drawLineTo",  self.drawLineTo);
      //   console.log("--");
      //   console.log("pointOnTheNextLine", pointOnTheNextLine);
      //   console.log("nextLine.drawLineFrom", nextLineFromPointField);
      //   console.log(" nextLine.drawLineTo",  nextLineToPointField);
      //   console.log("intersectionCords", intersectionCords);
      //   debugger // eslint-disable-line no-debugger
      // }
    }

    return intersectionCords
  }

  const getBorderFromIntersection = (prevLine) => {
    let intersectionCords = false

    if (prevLine.drawLineFrom) {
      const prevLineToPointField = prevLine.to.getPointField(false);
      const prevLineFromPointField = prevLine.from.getPointField(false);
      const pointOnTheLineBeforeFrom = getPointOnTheLine(this.drawLineFrom, this.drawLineTo,25);
      const pointOnThePrevLine = getPointOnTheLine(prevLineToPointField, prevLineFromPointField, 25);
      intersectionCords = getIntersectCords(
        pointOnTheLineBeforeFrom.x,
        pointOnTheLineBeforeFrom.y,
        this.drawLineTo.x,
        this.drawLineTo.y,
        prevLineFromPointField.x,
        prevLineFromPointField.y,
        pointOnThePrevLine.x,
        pointOnThePrevLine.y,
      );
      // if (lineDirection.orientation === "SOUTHWEST") {
      //   console.log("--------");
      //   console.log("pointOnTheLineBeforeFrom", pointOnTheLineBeforeFrom);
      //   console.log("self.drawLineFrom", self.drawLineFrom);
      //   console.log("self.drawLineTo",  self.drawLineTo);
      //   console.log("--");
      //   console.log("pointOnThePrevLine", pointOnThePrevLine);
      //   console.log("prevLine.drawLineFrom", prevLine.drawLineFrom);
      //   console.log("prevLine.drawLineTo",  prevLine.drawLineTo);
      //   console.log("intersectionCords", intersectionCords);
      //   debugger // eslint-disable-line no-debugger
      // }
    }

    return intersectionCords
  }

  function getOutlineFromIntersection (prevLine) {
    let intersectionCords = false

    if (prevLine.drawLineFrom) {
      const pointOnTheLineBeforeFrom = getPointOnTheLine(self.drawLineFrom, self.drawLineTo,15);
      const pointOnThePrevLine = getPointOnTheLine(prevLine.drawLineTo, prevLine.drawLineFrom, 15);
      intersectionCords = getIntersectCords(
        pointOnTheLineBeforeFrom.x,
        pointOnTheLineBeforeFrom.y,
        self.drawLineTo.x,
        self.drawLineTo.y,
        prevLine.drawLineFrom.x,
        prevLine.drawLineFrom.y,
        pointOnThePrevLine.x,
        pointOnThePrevLine.y,
      );
      // if (lineDirection.orientation === "SOUTHWEST") {
      //   console.log("--------");
      //   console.log("pointOnTheLineBeforeFrom", pointOnTheLineBeforeFrom);
      //   console.log("self.drawLineFrom", self.drawLineFrom);
      //   console.log("self.drawLineTo",  self.drawLineTo);
      //   console.log("--");
      //   console.log("pointOnThePrevLine", pointOnThePrevLine);
      //   console.log("prevLine.drawLineFrom", prevLine.drawLineFrom);
      //   console.log("prevLine.drawLineTo",  prevLine.drawLineTo);
      //   console.log("intersectionCords", intersectionCords);
      //   debugger // eslint-disable-line no-debugger
      // }
    }
    return intersectionCords
  }

  function getOutlineToIntersection (nextLine) {
    let intersectionCords = false
    if (nextLine.drawLineTo) {
      const pointOnTheLine = getPointOnTheLine(self.drawLineTo, self.drawLineFrom,12);
      const pointOnTheNextLine = getPointOnTheLine(nextLine.drawLineFrom, nextLine.drawLineTo, 12);
      intersectionCords = getIntersectCords(
        self.drawLineFrom.x,
        self.drawLineFrom.y,
        pointOnTheLine.x,
        pointOnTheLine.y,
        pointOnTheNextLine.x,
        pointOnTheNextLine.y,
        nextLine.drawLineTo.x,
        nextLine.drawLineTo.y,
      );

      // if (lineDirection.orientation === "SOUTHWEST") {
      //   console.log("--------");
      //   console.log("pointOnTheLine", pointOnTheLine);
      //   console.log(" self.drawLineFrom", self.drawLineFrom);
      //   console.log(" self.drawLineTo",  self.drawLineTo);
      //   console.log("--");
      //   console.log("pointOnTheNextLine", pointOnTheNextLine);
      //   console.log("nextLine.drawLineFrom", nextLine.drawLineFrom);
      //   console.log("nextLine.drawLineTo",  nextLine.drawLineTo);
      //   console.log("intersectionCords", intersectionCords);
      //   debugger // eslint-disable-line no-debugger
      // }
    }
    return intersectionCords
  }

  /**
   * Draw grey outline
   */
  const drawLine = (color, border) => {
    void border;
    self.setLinePoints();// dev remove to hide gray outline border
    self.ctx.beginPath();
    if (self.drawLineFrom && self.drawLineTo) {
      if (state.withBumpout) {
        self.ctx.moveTo(self.drawLineFrom.x, self.drawLineFrom.y);
        self.ctx.lineTo(self.drawLineBumpoutPoints.point1.x, self.drawLineBumpoutPoints.point1.y);

        self.ctx.moveTo(self.drawLineBumpoutPoints.point1.x, self.drawLineBumpoutPoints.point1.y);
        self.ctx.lineTo(self.drawLineBumpoutPoints.point2.x, self.drawLineBumpoutPoints.point2.y);

        self.ctx.moveTo(self.drawLineBumpoutPoints.point2.x, self.drawLineBumpoutPoints.point2.y);
        self.ctx.lineTo(self.drawLineBumpoutPoints.point3.x, self.drawLineBumpoutPoints.point3.y);

        self.ctx.moveTo(self.drawLineBumpoutPoints.point3.x, self.drawLineBumpoutPoints.point3.y);
        self.ctx.lineTo(self.drawLineBumpoutPoints.point4.x, self.drawLineBumpoutPoints.point4.y);

        self.ctx.lineTo(self.drawLineBumpoutPoints.point4.x, self.drawLineBumpoutPoints.point4.y);
        self.ctx.lineTo(self.drawLineTo.x, self.drawLineTo.y);
      } else {
        self.ctx.moveTo(self.drawLineFrom.x, self.drawLineFrom.y);
        self.ctx.lineTo(self.drawLineTo.x, self.drawLineTo.y);
      }
    }
    self.ctx.lineWidth = 8;
    self.ctx.strokeStyle = color;
    self.ctx.stroke();
    self.ctx.closePath();
  }

  const drawCorner = (color) => {
    self.ctx.beginPath();
    self.ctx.lineWidth = 8;
    self.ctx.strokeStyle = color;

    let
      renderTo    = self.calculateRenderPosition(self.to),
      renderFrom  = self.calculateRenderPosition(self.from),
      //radius      = Math.sqrt(Math.pow(self.to.arcLength, 2) / 2) * config.scale + 18,
      radius      = self.to.arcLength * config.scale,
      nextLine    = parent.getNextLine(self);

    lineDirection = parent.getAngleDirection(self);
    // var midHyp = getMidPoint(ap.line1, ap.line2);
    if (lineDirection.orientation !== "horizontal" && lineDirection.orientation !== "vertical") {
      //prevLine = parent.getPrevLine(self);
      //nextLine = parent.getNextLine(self);
      //prevParallelLine = parent.getPrevLine(prevLine);
    }

    switch (lineDirection.orientation) {
      case "horizontal":
      case "vertical":
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        const interSectionPoint = getOutlineIntersectionPointWithNextTLine();
        //v1
        const nextLineTo = this.calculateRenderPosition(nextLine.to);
        if (isInnerCorner(parent, renderFrom, renderTo, nextLineTo)) {
          radius = radius - 18
          if (radius < -8) { // set minimum radius to display
            radius = -8
          }
        }
        this.ctx.moveTo(this.drawLineTo.x, this.drawLineTo.y);
        this.ctx.arcTo(interSectionPoint.x, interSectionPoint.y, nextLine.drawLineFrom.x, nextLine.drawLineFrom.y, radius + 9);

        this.ctx.moveTo(nextLine.drawLineFrom.x, nextLine.drawLineFrom.y);
        this.ctx.arcTo(interSectionPoint.x, interSectionPoint.y, this.drawLineTo.x, this.drawLineTo.y, radius + 9);
        //v2
        // this.ctx.moveTo(this.drawLineFrom.x, this.drawLineFrom.y);
        // this.ctx.arcTo(interSectionPoint.x, interSectionPoint.y, nextLine.drawLineFrom.x, nextLine.drawLineFrom.y, radius + 9);
        // this.ctx.stroke();
        // this.ctx.closePath();
        //
        // this.ctx.beginPath();
        // this.ctx.strokeStyle = design.aroundLineColor;
        // this.ctx.moveTo(this.drawLineFrom.x, this.drawLineFrom.y);
        // this.ctx.lineTo(this.drawLineTo.x, this.drawLineTo.y);

        //v3
        //this.ctx.moveTo(this.drawLineTo.x, this.drawLineTo.y);
        //this.ctx.quadraticCurveTo(renderTo.x, renderTo.y, nextLine.drawLineFrom.x, nextLine.drawLineFrom.y);
        break;
      }
      default:
        break;
    }

    self.ctx.stroke();
    self.ctx.closePath();
  }

  const drawAngle = (color) => {
    let strokeStyle;

    this.ctx.beginPath();
    this.ctx.lineWidth = 8;

    this.ctx.strokeStyle = design.aroundLineColor;
    this.ctx.lineCap = 'square';
    //this.ctx.lineCap = 'round';

    if (this.lineCorner.state.isHovering && EventManager.getCursor().indexOf("delete") >= 0
      && (this.lineCorner.state.withEdge || this.lineCorner.state.withBacksplash || this.lineCorner.state.withWall || (this.lineCorner.state.attachedItems && this.lineCorner.state.attachedItems.isWithEndCap))) {
      strokeStyle = 'rgba(208,1,27,0.5)';
    } else if (this.lineCorner.state.withEdge) {
      strokeStyle = Color.getOutlineStrokeStyle('edge');
    } else if (this.lineCorner.state.withBacksplash) {
      strokeStyle = Color.getOutlineStrokeStyle('backsplash');
    } else if (this.lineCorner.state.attachedItems && this.lineCorner.state.attachedItems.isWithEndCap) {
      strokeStyle = Color.getOutlineStrokeStyle(RESOURCE_ATTACHED_TO_TYPE.end_cap);
    } else if (this.lineCorner.state.withWall) {
      strokeStyle = Color.getOutlineStrokeStyle('wall');
    } else if (config.highlight.lines && this.lineCorner.state.isHovering) {
      strokeStyle = Color.getOutlineHoverStrokeStyle();
      this.ctx.strokeStyle = strokeStyle;
    } else if (config.highlight.lines && config.highlight.demoShow && (config.highlight.id !== state.withId)) {
      strokeStyle = Color.getOutlineHoverStrokeStyle();
    }

    let angleLinePoints = this.lineCorner.getAnglePoints();

    this.ctx.strokeStyle = strokeStyle ? strokeStyle : color;
    this.ctx.moveTo(angleLinePoints.cord1.x, angleLinePoints.cord1.y);
    this.ctx.lineTo(angleLinePoints.cord2.x, angleLinePoints.cord2.y);
    this.ctx.lineTo(angleLinePoints.cord3.x, angleLinePoints.cord3.y);
    this.ctx.lineTo(angleLinePoints.cord4.x, angleLinePoints.cord4.y);

    this.ctx.moveTo(angleLinePoints.cord4.x, angleLinePoints.cord4.y);

    //this.ctx.moveTo(angleLinePoints.cord2.x, angleLinePoints.cord2.y);
    //this.ctx.lineTo(angleLinePoints.cord3.x, angleLinePoints.cord3.y);
    this.ctx.stroke();
    this.ctx.closePath();

    //purple line v2
    // this.ctx.beginPath();
    // this.ctx.strokeStyle = strokeStyle ? strokeStyle : color;
    // this.ctx.moveTo(angleLinePoints.cordCornerFrom.x, angleLinePoints.cordCornerFrom.y);
    // this.ctx.lineTo(angleLinePoints.cordCornerTo.x, angleLinePoints.cordCornerTo.y);

    //purple line v3
    // this.ctx.beginPath();
    // this.ctx.strokeStyle = color;
    // this.ctx.moveTo(angleLinePoints.cordCornerFrom.x, angleLinePoints.cordCornerFrom.y);
    // this.ctx.lineTo(angleLinePoints.cordCornerTo.x, angleLinePoints.cordCornerTo.y);

    this.ctx.stroke();
    this.ctx.closePath();
  }

  this.get45CornerLegDistanceScaled = () => {
    return get45CornerLegDistanceByHypotenuse(this.to.angle || this.to.arcLength) * config.scale
  };

  this.get45CornerLegDistance = () => {
    return get45CornerLegDistanceByHypotenuse(this.to.angle || this.to.arcLength)
  };

  this.deleteBumpout = () => {
    state.withBumpout = false;
    this.bumpoutOverlay.destroy();
    this.overlay.setMidpointOffset(0, 0);
    let bumpoutPoints = this.bumpoutOverlay.getBumpoutPoints();
    for (const pointName in bumpoutPoints) {
      if (bumpoutPoints.hasOwnProperty(pointName)) {
        bumpoutPoints[pointName].destroy();
      }
    }
    this.bumpoutOverlay = null;
  };

  this.deleteMitered = () => {
    state.isWithMitered = false;
    this.miteredOverlay.destroy();
    this.miteredOverlay = null;
    this.overlay.setMidpointOffset(0, 0);
    this.createLineLength();
  };

  this.deleteUnderlayment = () => {
    state.isWithUnderlayment = false;
    this.underlaymentOverlay.destroy();
    this.underlaymentOverlay = null;
    this.overlay.setMidpointOffset(0, 0);
    this.createLineLength();
  };

  this.deleteWaterfallTool = () => {
    this.waterfallOverlay.destroy();
    workspaceControllers.waterfall.destroy(this.waterfallOverlay);
    this.waterfallOverlay = null;
  };

  this.createLineLength = () => {
    this.overlay = new lineLength();
    this.overlay.init(self);
  };

  this.deleteAttachedItem = () => {
    state.withEdge = false;
    state.isWithWaterfallEdge = false;
    state.isWithPeninsulaUnderwrapEdge = false;
    state.withBacksplash = false;
    state.withWall = false;
    state.withBumpout = false;
    state.withId = null;
    for (const attachedItemsKey in state.attachedItems) {
      state.attachedItems[attachedItemsKey] = false
    }
    this.attachedShape = null;
    if (this.overlay) {
      this.overlay.removeLineText();
    }

    if (this.bumpoutOverlay) {
      this.deleteBumpout();
    }
    if (this.labelOverlay) {
      this.labelOverlay.destroy();
    }
    if (this.titleOverlay) {
      this.titleOverlay.destroy();
    }
    if (this.miteredOverlay) {
      this.deleteMitered();
    }
    if (this.underlaymentOverlay) {
      this.deleteUnderlayment();
    }
    if (this.waterfallOverlay) {
      this.deleteWaterfallTool();
    }
    sqftSlabManager.deleteSlabBacksplashByLine(this);
    store.dispatch(deleteResourceAttachedTo(RESOURCE_TYPE.attachedToLine, this));
  };

  this.addEdgeToLine = (edgeName, id) => {
    state.withEdge = true;
    state.withBacksplash = false;
    state.withWall = false;
    state.isWithWaterfallEdge = false;
    state.isWithPeninsulaUnderwrapEdge = false;
    state.withId = id;
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    if (this.overlay && this.overlay.renderEdgeText) {
      self.overlay.renderEdgeText(edgeName);
    }
  };

  this.addBacksplashToLine = (backsplashName, type, featureId, backsplashHeight) => {
    if (type === "wall") {
      state.withWall = true;
      state.withBacksplash = false;
    } else {
      state.withBacksplash = true;
      state.withWall = false;
    }
    state.withEdge = false;
    state.backsplashName = backsplashName;
    state.backsplashType = type;
    state.isWithWaterfallEdge = false;
    state.isWithPeninsulaUnderwrapEdge = false;
    state.withId = featureId;
    this.setBacksplashHeight(backsplashHeight);
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    self.overlay.renderBacksplashText(backsplashName, type);
  };

  this.addCrownMoldingToLine = (crownMoldingName, type, id) => {
    state.withBacksplash = false;
    state.withWall = false;
    state.withEdge = false;
    state.isWithWaterfallEdge = false;
    state.isWithPeninsulaUnderwrapEdge = false;
    state.attachedItems.isWithCrownMolding = true;
    state.withId = id;
    //this.overlay.renderBacksplashText(crownMoldingName, type);
  };

  this.addEndCapToLine = (endCapName, type, id) => {
    state.withBacksplash = false;
    state.withWall = false;
    state.withEdge = false;
    state.isWithWaterfallEdge = false;
    state.isWithPeninsulaUnderwrapEdge = false;
    state.attachedItems.isWithEndCap = true;
    state.attachedItems.isWithCrownMolding = false;
    state.withId = id;
    //this.overlay.renderBacksplashText(crownMoldingName, type);
  };

  this.addBumpoutToLine = (resourceId) => {
    //todo allow add multiple bumpout
    if (!state.withBumpout) {
      //todo fix rotation
      if (self.getOrientation() === orientation.VERTICAL || self.getOrientation() === orientation.HORIZONTAL) {
        state.withBumpout = true;
        self.bumpoutOverlay = new bumpout(resourceId);
        self.bumpoutOverlay.init(self);
      }
    }
  };

  this.addMiteredToLine = () => {
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    if (!state.isWithMitered) {
      this.deleteAttachedItem();
      state.isWithMitered = true;
      if (workspace.miteredController === null) {
        workspace.miteredController = new MiteredController();
      }
      this.miteredOverlay = workspace.miteredController.createMiteredOverlay(this);
      this.miteredOverlay.init();

      return this.miteredOverlay;
    }

    return this.miteredOverlay
  };

  this.addUnderlaymentToLine = () => {
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    if (!state.isWithUnderlayment) {
      //todo fix rotation
      this.deleteAttachedItem();
      if (this.getOrientation() === orientation.VERTICAL || this.getOrientation() === orientation.HORIZONTAL) {
        state.isWithUnderlayment = true;
        if (workspace.underlaymentController === null) {
          workspace.underlaymentController = new UnderlaymentController();
        }
        this.underlaymentOverlay = workspace.underlaymentController.createUnderlaymentOverlay(this);
        this.underlaymentOverlay.init();

        return this.underlaymentOverlay;
      }
    }

    return this.underlaymentOverlay
  };

  this.addWaterfallToLine = (name = RESOURCE_ATTACHED_TO_NAME.waterfall, waterfallImportData) => {
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    if (!this.isWithWaterfallToolEdge() || waterfallImportData) {
      this.deleteAttachedItem();
      if (this.getOrientation() === orientation.VERTICAL || this.getOrientation() === orientation.HORIZONTAL) {
        state.isWithWaterfallEdge = true;
        state.isWithPeninsulaUnderwrapEdge = false;
        state.withBacksplash = false;
        state.withWall = false;
        state.withEdge = false;
        this.waterfallOverlay = workspaceControllers.waterfall.createWaterfallOverlay(this, waterfallImportData);
        createSlabModeWaterfallShapes();
        this.overlay.renderWaterfallText(name, RESOURCE_ATTACHED_TO_TYPE.waterfall);

        return this.waterfallOverlay;
      }
    }
    return this.waterfallOverlay
  };

  this.addPeninsulaUnderwrapToLine = () => {
    for (const attachedItemKey in state.attachedItems) {
      state.attachedItems[attachedItemKey] = false
    }
    if (!this.isWithPeninsulaUnderwrapEdge()) {
      if (this.getOrientation() === orientation.VERTICAL || this.getOrientation() === orientation.HORIZONTAL) {
        state.isWithPeninsulaUnderwrapEdge = true;
        state.isWithWaterfallEdge = false;
        state.withBacksplash = false;
        state.withWall = false;
        state.withEdge = false;
        this.waterfallOverlay = workspaceControllers.waterfall.createPeninsulaUnderwrapOverlay(this);
        createSlabModeWaterfallShapes();

        return this.waterfallOverlay;
      }
    }
    return this.waterfallOverlay
  };

  this.renderLineField = (ctx) => {
    this.ctx = ctx;

    if (config.highlight.tutorial && self.highLightedByTutorial) {
      drawLine('#E3E1E3');
      highLightBorder('#b263a8');
      if (self.tutorialImage) {
        drawResizeCursor();
      }
    } else if (config.highlight.lines && state.isHovering) {
      switch (config.highlight.type) {
        case 'edge':
          if (config.highlight.id !== state.withId) {
            drawLine(COLOR_THEMES[config.activeTheme].active_transparent);
          } else {
            drawLine(COLOR_THEMES[config.activeTheme].active);
          }
          break;
        case RESOURCE_ATTACHED_TO_TYPE.backsplash:
        case RESOURCE_ATTACHED_TO_TYPE.waterfall:
          if (config.highlight.id !== state.withId) {
            drawLine(COLOR_THEMES[config.activeTheme].primary_transparent);
          } else {
            drawLine(COLOR_THEMES[config.activeTheme].primary);
          }
          break;
        case 'wall':
          if (config.highlight.id !== state.withId) {
            drawLine('rgba(0,0,0,0.5)');
          } else {
            drawLine(COLOR_THEMES[config.activeTheme].primary);
          }
          break;
        case RESOURCE_ATTACHED_TO_TYPE.end_cap:
          if (config.highlight.id !== state.withId) {
            drawLine(COLOR.red_transparent);
          } else {
            drawLine(COLOR.red);
          }
          break;
        default:
          drawLine(COLOR_THEMES[config.activeTheme].active_transparent);
          break;
      }
    } else if (config.highlight.lines && config.highlight.demoShow && (config.highlight.id !== state.withId)) {
      switch (config.highlight.type) {
        case 'edge':
        default:
          drawLine(COLOR_THEMES[config.activeTheme].active_transparent);
          break;
        case RESOURCE_ATTACHED_TO_TYPE.backsplash:
        case RESOURCE_ATTACHED_TO_TYPE.end_cap:
        case RESOURCE_ATTACHED_TO_TYPE.waterfall:
          drawLine(COLOR_THEMES[config.activeTheme].primary_transparent);
          break;
        case 'wall':
          drawLine('rgba(0,0,0,0.5)');
          break;
      }
    } else if (this.blink.isActive) {
      // Helper function to get the base (off) color for the line
      const getLineBaseColor = () => {
        if (state.withEdge || this.isWithPeninsulaUnderwrapEdge?.()) {
          return COLOR_THEMES[config.activeTheme].active;
        } else if (state.withBacksplash || this.isWithWaterfallToolEdge?.()) {
          return COLOR_THEMES[config.activeTheme].primary;
        } else if (state.withBumpout) {
          return '#E3E1E3';
        } else if (state.withWall) {
          return '#000000';
        } else if (state.attachedItems?.isWithEndCap) {
          return COLOR.red;
        }
        return '#E3E1E3';
      };

      // Helper function to get the highlighted (on) color for the line
      const getLineHighlightColor = () => {
        if (state.withEdge || this.isWithPeninsulaUnderwrapEdge?.()) {
          return COLOR_THEMES[config.activeTheme].active_transparent;
        } else if (state.withBacksplash || this.isWithWaterfallToolEdge?.()) {
          return COLOR_THEMES[config.activeTheme].primary_transparent;
        } else if (state.withBumpout) {
          return COLOR_THEMES[config.activeTheme].primary_transparent;
        } else if (state.withWall) {
          return 'rgba(0,0,0,0.5)';
        } else if (state.attachedItems?.isWithEndCap) {
          return COLOR.red_transparent;
        }
        return COLOR_THEMES[config.activeTheme].primary_transparent;
      };

      const lineColor = pickPulsedColor(
        getLineHighlightColor,
        getLineBaseColor,
        this.blink.progress,
        this.blink.override
      );

      if (lineColor) drawLine(lineColor);
    } else {
      if (workspace.getAllowEdges() && workspace.getAllowLineHighlight()) {
        highLightBorder('#b263a8');
      }

      if (config.workspace.debug || state.isHovering && !config.highlight.lines && workspace.getAllowEdges()) {
        highLightBorder('#b263a8');
      }

      const orientation = this.getLineDirection().orientation;
      const isBumpoutHighlighted = workspace.getAllowBumpoutEdges() && workspace.getAllowLineHighlight();
      const isMiteredHighlighted = workspace.getAllowMiteredEdges() && workspace.getAllowLineHighlight();
      if ((isBumpoutHighlighted || isMiteredHighlighted)
        && (orientation === "vertical" || orientation === "horizontal")
      ) {
        highLightBorder(COLOR_THEMES[config.activeTheme].primary);
      }

      if (config.workspace.debug
        || state.isHovering && !config.highlight.lines
        && (
          (workspace.getAllowBumpoutEdges() || workspace.getAllowMiteredEdges())
          && (orientation === "vertical" || orientation === "horizontal")
        )
      ) {
        highLightBorder(COLOR_THEMES[config.activeTheme].primary);
      }

      if (state.isHovering && EventManager.getCursor().indexOf("delete") >= 0
        && (state.withEdge
          || state.withBacksplash
          || (state.attachedItems && state.attachedItems.isWithEndCap)
          || state.withWall
          || this.isWithPeninsulaUnderwrapEdge()
          || this.isWithWaterfallToolEdge())
      ) {
        drawLine('rgba(208,1,27,0.5)');
      } else if (state.withEdge || this.isWithPeninsulaUnderwrapEdge()) {
        drawLine(COLOR_THEMES[config.activeTheme].active);
        if (self.tutorialImage) {
          drawResizeCursor();
        }
      } else if (state.withBacksplash) {
        drawLine(COLOR_THEMES[config.activeTheme].primary);
      } else if (this.isWithWaterfallToolEdge()) {
        drawLine(COLOR_THEMES[config.activeTheme].primary);
      } else if (state.withWall) {
        drawLine('#000000');
      } else if (state.withBumpout) {
        drawLine('#E3E1E3');
      } else if (state.attachedItems && state.attachedItems.isWithEndCap) {
        drawLine(COLOR.red);
      } else {
        drawLine('#E3E1E3');
      }
    }

    if (self.to.arcLength > 0) {
      if (EventManager.getCursor().indexOf("delete") >= 0 && !state.isHovering && self.to.isOverPointField()) {
        drawCorner('rgba(208,1,27,0.5)');
      } else {
        drawCorner("#b263a8")
      }
    }

    //todo move this to lineCorner
    if (self.to.angle > 0) {
      if (EventManager.getCursor().indexOf("delete") >= 0
        && !state.isHovering
        && (self.to.isOverPointField() || self.lineCorner.state.isCornerLineHovering) // todo perhaps hover over Point should be removed?
      ) {
        drawAngle('rgba(208,1,27,0.5)');
      } else {
        drawAngle("#b263a8")
      }
    }
    ctx.restore();
  };
}
